module.exports = __webpack_public_path__ + "static/media/santa_with_sack_full.d2cfc12e.png";